import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_Malaria_CLinics = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />{" "}
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
            <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass">
                      {" "}
                      {t("KMC Malaria Clinics")}{" "}
                    </h3>
                  </div>
                  <div className="health-dept-table" style={{ width: "100%" }}>
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="center"
                          valign="middle"
                        >
                          <td
                            width="20%"
                            className="text-white tble-brder-left"
                          >
                            {t("Borough")}
                          </td>
                          <td width="50%" className="text-white">
                            {t("Clinic Name")}
                          </td>
                          <td
                            width="30%"
                            className="text-white tble-brder-right"
                          >
                            {t("Address")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> I </td>
                          <td>{t("Municipal Dispensary, Chitpur")}</td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> ||</td>
                          <td width={800}>
                            {t("Hatibagan Dispensary")}
                            <br />
                            {t(
                              "Allen Market Dispensary, Malaria Detection Centre: WHU - 19, W.H.U. - 15, W.H.U. - 16"
                            )}
                            <br />
                            {t("M.D.C. At Nilmoni Mitra St")}
                            <br />
                            {t("WHU. - 20, W.H.U. - 12")}
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">|||</td>
                          <td>
                            {t("Ultadanga Dispensary")}
                            <br />
                            {t("Rajabazar Dispensary")}
                            <br />
                            {t("Narkeldanga Dispensary")}
                            <br />
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> IV</td>
                          <td>
                            {t("Jorabagan Park")}
                            <br />
                            {t("WHU, Raja U Street")}
                            <br />
                            {t("Girish Park Clinic")}
                            <br />
                            {t("Sukia Street VAC, Centre: WHU - 26, WHU - 23")}
                            <br />
                            {t("WHU - 24, W.H.U. - 39")}
                            <br />
                            {t("WHU - 25, W.H.U. - 22")} <br />
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> V</td>
                          <td>
                            {t("Bathakkhana Dispensary, Shraddhananda Park")}
                            <br />
                            {t("Nafar Kolay Dispensar, Bagola Clinic")}
                            <br />
                            {t(
                              "HQ - Br V, Surya Sen Street, WHU - WD - 36"
                            )}{" "}
                            <br />
                            {t("W.H.U. - 41, WHU WD 45")}
                            <br />
                            {t("WHU - 44, WHU - 50")}
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> VI</td>
                          <td>
                            {t("Taltala Dispensary")}
                            <br />
                            {t("WHU 60 + 61")}
                            <br />
                            {t("Haji Md. M.SQ Dispensary")}
                            <br />
                            {t("WHU - 46 + 47")}
                          </td>
                          <td>
                            <br />
                            {t("42, Jannagore Road")}
                            <br />
                            <br />
                            {t("16, Jadunath Dey Road")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> VII </td>
                          <td>
                            {t("Gobra Dispensary, Tiljala Dispensary")}
                            <br />
                            {t("S. Roy Road Clinic, New Tangra Dispensary")}
                            <br />
                            {t(
                              "Palm Avenue Dispensary, Sundari Mohan Avenue Dispensary, Topsia Clinic HQ - BR - VII"
                            )}
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">VIII</td>
                          <td>
                            {t("Ballygunge Phari Clinic, Bhowanipur Clinic")}
                            <br />
                            {t(
                              "Vivekananda Park ward Office, Southern Avenue WHU, Ward No 85, W.H.U. - 68"
                            )}
                            <br />
                            {t("W.H.U. - 84, W.H.U. - 72")}
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> IX </td>
                          <td>
                            {t("Kalighat Dispensary, Khidderpore Dispensary")}
                            <br />
                            {t("Chetla Dispensary, WHU - 84")}
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> X </td>
                          <td>{t("Tollygunge Clinic, Cachtala Clinic")} </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> XI </td>
                          <td>{t("Atabagan Clinic")} </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> XII </td>
                          <td>{t("Ramlal Bazar Clinic ")}</td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> XIII </td>
                          <td>
                            {t("Barisha Matrisadan, Buroshibtala M.D.C")}.{" "}
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> XIV </td>
                          <td>{t("Panchanantala (S.S.M.L. & Disp)")} </td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center"> XV </td>
                          <td>{t("Garden Reach Clinic, W.H.U.-141, VCD")}</td>
                          <td>&nbsp;</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_Malaria_CLinics;
